import type { ReactNode } from 'react';

export const symbol_nest_thermostat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M416-572 306-378q-3 6-1.5 12.5t7.5 9.5q6 3 12.5 1.5t9.5-7.5l114-204 2-7v-17q0-6-4-10t-10-4H293q-6 0-10 4t-4 10q0 6 4.5 10.5T294-575h120l2 3Zm230.5 186.5Q671-423 671-480t-25-94.5Q621-612 573-612q-49 0-73 37.5T476-480q0 57 24 94.5t73 37.5q49 0 73.5-37.5ZM573-378q-28 0-47.5-24.5T506-480q0-46 17-74t50-28q33 0 50.5 28t17.5 74q0 53-19.5 77.5T573-378ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
